import React, { PureComponent } from 'react';
import { number, string, func, object } from 'prop-types';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

class SourcesListItem extends PureComponent {
  static propTypes = {
    id: number.isRequired,
    title: string.isRequired,
    types: object.isRequired,
    onRemove: func.isRequired,
    onEdit: func.isRequired,
  };

  handleItemRemove = (e) => {
    e.preventDefault();
    this.props.onRemove(this.props.id);
  };

  handleItemEdit = (e) => {
    e.preventDefault();
    const { id, title } = this.props;
    this.props.onEdit({ id, title });
  };

  getSiteType = (typeId) =>
    this.props.types[typeId] !== undefined ? this.props.types[typeId] : typeId;

  render() {
    const { id, title, type, url } = this.props;

    return (
      <tr>
        <td>{id}</td>
        <td>{title}</td>
        <td>{url ? url : this.getSiteType(type)}</td>
        <td className="table-controls">
          <a className="site-control edit-site" role="button" onClick={this.handleItemEdit}>
            <SVG
              src={`${STATIC_PATH}/img/action-icons/edit_icon.svg`}
              height="20"
              width="20"
              cacheRequests
            />
          </a>
        </td>
        <td className="table-controls">
          <a className="site-control remove-site" role="button" onClick={this.handleItemRemove}>
            <SVG
              src={`${STATIC_PATH}/img/action-icons/bin_icon.svg`}
              height="20"
              width="20"
              cacheRequests
            />
          </a>
        </td>
      </tr>
    );
  }
}

export default SourcesListItem;
